import { useState } from "react";
import { Link } from "react-router-dom";
import "./about.css";

const SERVICES = [
  {
    id: "mutual-funds",
    icon: "fa-chart-column",
    title: "Mutual Funds",
    desc: "Curated investment solutions across top fund houses to help you grow your wealth.",
    to: "/mutual-fund",
  },
  {
    id: "loans",
    icon: "fa-hand-holding-dollar",
    title: "Loans",
    desc: "Flexible home, personal, and business loan options with competitive rates and quick approval.",
    to: "/Loan",
  },
  {
    id: "wealth",
    icon: "fa-handshake",
    title: "Wealth Management",
    desc: "Personalized wealth strategies designed to protect, grow, and transfer your assets wisely.",
    to: "/contact",
  },
  {
    id: "sip",
    icon: "fa-piggy-bank",
    title: "SIP Planning",
    desc: "Disciplined SIP plans that help you build long-term wealth with small, regular investments.",
    to: "/mutual-fund",
  },
  {
    id: "tax",
    icon: "fa-file-invoice-dollar",
    title: "Tax Planning",
    desc: "Smart tax-efficient solutions that help you save more while staying fully compliant.",
    to: "/contact",
  },
  {
    id: "financial",
    icon: "fa-clipboard-check",
    title: "Financial Planning",
    desc: "Goal-based financial planning to secure your future with clarity and confidence.",
    to: "/contact",
  },
];

export default function AboutServices() {
  const [activeId, setActiveId] = useState(SERVICES[0].id);
  const active = SERVICES.find((s) => s.id === activeId) || SERVICES[0];

  return (
    <section className="about-services-new">
      <div className="about-services-inner">
        <header className="about-section-head">
          <p className="about-eyebrow">WHAT WE DO</p>
          <h2>Our Core Services</h2>
        </header>

        <div className="about-service-grid" role="tablist" aria-label="Core services">
          {SERVICES.map((service) => (
            <button
              key={service.id}
              type="button"
              role="tab"
              aria-selected={activeId === service.id}
              className={`about-service-card${
                activeId === service.id ? " is-active" : ""
              }`}
              onClick={() => setActiveId(service.id)}
            >
              <span className="about-service-icon" aria-hidden="true">
                <i className={`fa-solid ${service.icon}`} />
              </span>
              <span>{service.title}</span>
            </button>
          ))}
        </div>

        <p className="about-service-desc">{active.desc}</p>
        <Link to={active.to} className="about-service-link">
          Explore All Services <span aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  );
}
